module.exports = __webpack_public_path__ + "img/magazine42.35010f59.jpg";